import { Injectable } from "@angular/core";
import { DeviceConfigService, DeviceType, WindowRef } from "@obg/ngx.global";
import { fromEvent, Observable, of } from "rxjs";
import { distinctUntilChanged, map, startWith } from "rxjs/operators";

import { ViewportBreakpointConfigService } from "./viewport-breakpoint.config";
import { ViewportSize } from "./viewport-breakpoint.model";

export abstract class ViewportBreakpointService {
	abstract viewportSize$: Observable<ViewportSize>;
}

@Injectable()
export class BrowserViewportBreakpointService implements ViewportBreakpointService {
	viewportSize$: Observable<ViewportSize>;
	private config = this.viewportConfigService.getViewportSizes();
	private sizes = [
		this.config.small,
		ViewportSize.Small,
		this.config.medium,
		ViewportSize.Medium,
		this.config.large,
		ViewportSize.Large,
		this.config.extraLarge,
		ViewportSize.ExtraLarge,
	];

	constructor(
		private windowRef: WindowRef,
		private viewportConfigService: ViewportBreakpointConfigService
	) {
		this.viewportSize$ = fromEvent(windowRef.native, "resize").pipe(
			startWith(this.getViewportSize()),
			map(() => this.getViewportSize()),
			distinctUntilChanged()
		);
	}

	private getViewportSize(): ViewportSize {
		const width = this.windowRef.native.innerWidth;
		for (let i = 0; i < this.sizes.length; i += 2) {
			if (width < this.sizes[i]) {
				return this.sizes[i + 1];
			}
		}

		return ViewportSize.XXL;
	}
}

@Injectable()
export class ServerViewportBreakpointService implements ViewportBreakpointService {
	viewportSize$ = of(
		{
			[DeviceType.Desktop]: ViewportSize.XXL,
			[DeviceType.Tablet]: ViewportSize.Medium,
			[DeviceType.Mobile]: ViewportSize.Small,
		}[this.deviceConfig.getType()]
	);

	constructor(private deviceConfig: DeviceConfigService) {}
}
